import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookies from 'js-cookie'
import enInLocale from './en-IN'
import esMxLocale from './es-MX'
import enMxLocale from './en-MX'

Vue.use(VueI18n)

const messages = {
  'en-IN': enInLocale,
  'es-MX': esMxLocale,
  'en-MX': enMxLocale
}

const i18n = new VueI18n({
  locale: 'en-IN',
  messages,
  fallbackLocale: 'en-IN'
})
export default i18n
